<header>
    <dac-sidebar class="sn-bg-1 fixed"></dac-sidebar>
    <dac-navbar [doubleNav]="true"></dac-navbar>
</header>
<main>
    <div class="container-fluid mb-3">
        <dac-announcement-bar></dac-announcement-bar>
        <router-outlet></router-outlet>
        <dac-subscription-dialog></dac-subscription-dialog>
    </div>
</main>


// WEBPACK FOOTER //
// ./src/app/admin/admin/admin.component.html